

import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';
import TabsNav from '@/components/tabs/TabsNavIcons.vue';

import DirectoriesModule from '@/store/directories';
import SubscriptionsModule from '@/store/subscriptions';
import SubscriptionTypessModule from '@/store/subscriptionTypes';

@Component({
    components: {
        Layout,
        ListBlock,
        TabsNav,
    }
})
export default class SubscriptionsPage extends Vue {
    repository = SubscriptionTypessModule;

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }


    get currentTab() {
        return DirectoriesModule.allTabs.subscriptions.id;
    }
    
    get tabsNavList() {
        return SubscriptionsModule.tabsNav;
    }

    get currentTabList() {
        return SubscriptionsModule.allTabs.subscriptionTypes.id;
    }

    toAdd() {
        this.$router.push({ name: 'subscriptionTypes_create' });
    }
}
